import { API } from "../api/axios";
const END_POINT_FILTER= "/time-sheet-filter";
const END_POINT_CLASS= "/time-sheet-class";
const END_POINT_STATS= "/time-sheet-stats";
const END_POINT_STUDENTS= "/students-list";
const END_POINT_RG_ADD= "/time-sheet";
class RegisterClass {
    getFilter(params) {
        return API.get(END_POINT_FILTER, params);
    }
    getClass(params) {
        return API.get(END_POINT_CLASS, params);
    }
    getStats(id) {
        return API.get(`${END_POINT_STATS}/${id}`);
    }
    getStudents(params) {
        return API.get(END_POINT_STUDENTS, params);
    }
    create(data) {
        return API.post(END_POINT_RG_ADD, data);
    }


    
}

export default new RegisterClass();

//Exemple d'utilisation dans les pages
/*getMessage(id) {
    MessageDataService.get(id)
    .then(response => {
    this.currentMessage = response.data;
    })
    .catch(e => {
    });
},*/
